import { logRefTag } from '@utils'
import { DeeplinkHandlerInput } from '.'
interface PType {
  when: (...args: string[]) => { execute: Function }
}
declare let window: Window & { P: PType }

const REF_TAG_SUCCESS = 'dv_web_dl_success'
const REF_TAG_FAILURE = 'dv_web_dl_failure'

export const deeplinkMshopIos = ({ url, fallbackUrl }: DeeplinkHandlerInput) => {
  window.P.when('mash').execute((mash: any) => {
    mash.launchIntentURL({
      url,
      successCallback: () => {
        logRefTag(REF_TAG_SUCCESS)
      },
      failCallback: async () => {
        if (fallbackUrl) {
          await logRefTag(REF_TAG_SUCCESS)
          // It is impossible to deeplink to the App Store with launchIntentURL on an iOS device.
          // Instead, setting window location will deeplink to the App Store.
          window.location.assign(fallbackUrl)
        } else {
          await logRefTag(REF_TAG_FAILURE)
        }
      },
    })
  })
}

export const deeplinkMShopAndroid = ({ url, fallbackUrl }: DeeplinkHandlerInput) => {
  window.P.when('mash').execute((mash: any) => {
    mash.canLaunchIntentURL({
      url,
      successCallback: async (canLaunch: boolean) => {
        if (canLaunch) {
          await logRefTag(REF_TAG_SUCCESS)
          mash.launchIntentURL({ url })
        } else {
          await logRefTag(REF_TAG_FAILURE)
          if (fallbackUrl) {
            mash.launchIntentURL({ url: fallbackUrl })
          }
        }
      },
      failCallback: () => {
        logRefTag(REF_TAG_FAILURE)
      },
    })
  })
}
